import { Injectable, signal } from '@angular/core';
import { AuthModel } from '@auth/models';
import { MenuLoginDTO } from '@features/login/dtos';

@Injectable({ providedIn: 'root' })
export class AccessControlService {
  private _isAdmin = signal<boolean>(false);
  private _menus = signal<MenuLoginDTO[]>([]);
  private _actionSet = signal<Set<string>>(new Set());

  readonly isAdminSig = this._isAdmin.asReadonly();
  readonly menusSig = this._menus.asReadonly();
  readonly actionSetSig = this._actionSet.asReadonly();

  load(auth: AuthModel) {
    this._isAdmin.set(!!auth.isAdmin);
    this._menus.set(auth.menus ?? []);

    const codes = new Set<string>();
    for (const m of auth.menus ?? []) for (const a of m.actions ?? []) codes.add(a.code);
    this._actionSet.set(codes);
  }

  clear() {
    this._isAdmin.set(false);
    this._menus.set([]);
    this._actionSet.set(new Set());
  }

  canAccessPath = (path: string) => this._menus().some((m) => m.path === path);

  can = (code: string) => this._actionSet().has(code);
}
